export default __webpack_public_path__ + "static/media/disable.6802a9c0.svg";